import React, { PureComponent } from 'react';

import cxHelpers from 'util/className';

@cxHelpers('FlexLayoutReset')
export default class FlexLayoutReset extends PureComponent {
  render() {
    return (
      <style
        dangerouslySetInnerHTML={{
          __html: `
          body.flex-layout {
            min-height: 0;
            height: 100%;
          }

          .flex-layout .main-wrapper {
            min-height: 0;
            position: relative;
            flex-grow: 1;
          }

          .flex-layout .body-container {
            display: flex;
            flex-direction: column;
          }

          .flex-layout #js-react-app-container {
            height: 100%;
            display: flex;
            flex-direction: column;
            position: absolute;
            width: 100%;
          }

          .flex-layout #react-app-root {
            flex-grow: 1;
            position: relative;
          }
        `,
        }}
      />
    );
  }
}
